<template>
  <div>
    <div class="page" v-if="!flag">
     <pcheader ></pcheader>
     <div id="main">
       <router-view></router-view>
     </div>
     <ke-fu></ke-fu>
     <pcfooter></pcfooter>
   </div>
   <div v-else>
     <phoneheader></phoneheader>
     <div class="phoneContent">
      <router-view></router-view> 
     </div>
      <phone-footer></phone-footer>
   </div>
    <!-- <div class="page">
      <pcheader ></pcheader>
      <div id="main">
        <router-view></router-view>
      </div>
      <ke-fu></ke-fu>
      <pcfooter></pcfooter>
    </div> -->
  </div>
</template>

<script>
export default {
  data(){
    return{
      flag:false
    }
  },
  created(){
    this.flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  }
}
</script>

<style scoped>
.page{
  min-width: 1200px;
 
  /* border: 1px solid red; */
}
#main{
    min-height: 93vh;
}
.phoneContent{
min-height: 60vh;
}
</style>
